export const text = {
  //general
  vnd: 'đ',
  edit: 'Sửa',
  EDIT: 'Chỉnh sửa',
  share: 'Chia sẻ',
  copy: 'Sao chép',
  add: 'Thêm',
  skip: 'Bỏ qua',
  notification: 'Thông báo',
  viewAll: 'Xem tất cả',
  viewNow: 'Xem ngay',
  viewDetail: 'Xem chi tiết',
  notes: 'Ghi chú',
  futaExpress: 'FUTA Express',
  changeAddress: 'Đổi địa chỉ',
  addAddressNew: 'Thêm địa chỉ mới',
  addAddressNewPlus: '+ Thêm địa chỉ mới',

  //store form
  address: 'Địa chỉ',
  email: 'Email',
  updateInfo: 'Cập nhật thông tin',
  deliveryInstructions: 'Hướng dẫn thêm cho nhân viên giao hàng',
  editInfo: 'Chỉnh sửa thông tin',
  otherDocs: 'Giấy tờ khác',
  profilePicture: 'Ảnh đại diện',
  storeName: 'Tên cửa hàng',
  enterStoreName: 'Nhập tên cửa hàng',
  enterEmail: 'Nhập Email',
  storeDescription: 'Mô tả cửa hàng',
  enterFullName: 'Nhập Họ và tên',
  fullName: 'Họ và tên',
  pleaseSelect: 'Vui lòng chọn',
  streetAddress: 'Số nhà/ đường',
  wardCommune: 'Phường/ Xã',
  districtCounty: 'Quận/ huyện',
  provinceCity: 'Tỉnh/ Thành phố',
  businessSector: 'Ngành hàng kinh doanh',
  businessAddress: 'Địa chỉ kinh doanh',
  representativeName: 'Họ Tên người đại diện',
  completeAndCreateProduct: 'Hoàn tất và bắt đầu tạo sản phẩm',
  storeDescriptionEmptyPrompt: 'Cửa hàng của bạn chưa có mô tả, nhấp vào biểu tượng "chỉnh sửa" để cập nhật thông tin cửa hàng của bạn nhé',
  setAsDefaultAddress: 'Đặt làm địa chỉ mặc định',
  storeEmailNote: 'Lưu ý: Thông tin đơn hàng sẽ gửi về địa chỉ mail đăng ký',

  //validate store form
  businessCategoryRequired: 'Ngành hàng kinh doanh là bắt buộc',
  addressRequired: 'Địa chỉ là trường bắt buộc',
  wardCommuneRequired: 'Phường/Xã là bắt buộc',
  addressNameRequired: 'Tên địa chỉ là bắt buộc',
  districtRequired: 'Quận/Huyện là bắt buộc',
  provinceCityRequired: 'Tỉnh/Thành phố là bắt buộc',
  businessAddressRequired: 'Địa chỉ kinh doanh là bắt buộc',
  invalidPhoneNumber: 'Số điện thoại không hợp lệ',
  phoneNumberRequired: 'Số điện thoại là bắt buộc',
  emailRequired: 'Email là bắt buộc',
  invalidEmail: 'Email không hợp lệ',
  representativeNameRequired: 'Họ Tên người đại diện là bắt buộc',
  storeNameRequired: 'Tên cửa hàng là bắt buộc',
  pickupTimeRangeRequired: 'Thời gian đơn vị vận chuyển lấy hàng là bắt buộc',
  wardCommuneInfoMissing: 'Chưa có thông tin Phường/ Xã của bạn',
  districtInfoMissing: 'Chưa có thông tin Quận/ huyện của bạn',
  provinceCityInfoMissing: 'Chưa có thông tin Tỉnh/ Thành phố phố của bạn',
  addressInfoMissing: 'Chưa có thông tin địa chỉ của bạn',
  infoMissing: 'Chưa có thông tin',
  shippingAddressRequired: 'Địa chỉ gửi hàng là bắt buộc',
  pleaseCompleteAllFields: 'Vui lòng nhập đủ thông tin',
  packageBeforeCarrierPickup: 'Bạn vui lòng đóng gói đơn hàng trước khi đơn vị vận chuyển đến lấy hàng',

  //shipping confirm
  ifAvailable: '(nếu có)',
  shipper: 'Người gửi hàng',
  confirmOrder: 'Xác nhận đơn hàng',
  shippingAddress: 'Địa chỉ gửi hàng',
  shippingCarrier: 'Đơn vị vận chuyển/ Nhà xe',
  senderName: 'Họ Tên người gửi hàng',
  shippingCompany: 'Đơn vị vận chuyển',
  transportByFutaFunongPartner: 'Vận chuyển bởi đối tác vận chuyển của FUTA FuNong',
  trackingNumber: 'Mã vận đơn',
  senderPhoneNumber: 'Số điện thoại người gửi',
  senderAddress: 'Địa chỉ của người gửi hàng',
  shippingCompanyTrackingCode: 'Mã vận đơn của đơn vị vận chuyển cung cấp',
  pickupAddress: '(địa chỉ nơi nhân viên giao hàng đến nhận)',
  selectOrderHandoverMethod: 'Chọn hình thức bàn giao đơn hàng',
  pickupAtLocation: 'Lấy hàng tận nơi',
  dropOffAtPostOffice: 'Gửi hàng tại bưu cục',
  pickupTime: 'Thời gian lấy hàng',
  viewPostOfficeList: 'Xem danh sách bưu cục',
  selectCarrierPickupTime: 'Chọn thời gian đơn vị vận chuyển qua lấy hàng',
  noDeliveryTimeSlots: 'Không có khung giờ giao hàng',
  confirmPackageAndDropOffInstructions: 'Bạn vui lòng bấm "Xác nhận" và đóng gói đơn hàng. Sau đó đem gửi hàng ra bưu cục của đơn vị vận chuyển',

  //order
  descriptionShopping: 'Cám ơn bạn đã mua hàng tại FUTA FuNong. Chúng tôi luôn cố gắng hoàn thiện để bạn có những trải nghiệm tốt nhất',
  orderSuccessful: 'Đặt hàng thành công!',
  orderTracking: 'Theo dõi đơn hàng',
  continueShopping: 'Theo dõi đơn hàng',
  waitingConfirm: 'Chờ xác nhận',
  orderProcessing: ' Đơn hàng của bạn đang được xử lý bởi nhà bán hàng',
  createProduct: 'Tạo sản phẩm',
  quantity: 'Số lượng',
  type: 'Loại',
  unitPrice: 'Đơn giá',
  estimatedShippingCost: 'Phí vận chuyển tạm tính',
  shippingCost: 'Phí vận chuyển',
  totalAmount: 'Thành tiền',
  agree: 'Đồng ý',
  confirm: 'Xác nhận',
  refund: 'Hoàn hàng',
  canceled: 'Huỷ bỏ',
  confirmDelivered: 'Xác nhận giao thành công',
  cancel: 'Huỷ',
  delete: 'Xoá',
  deleteAll: 'Xoá tất cả',
  cancelOrder: 'Huỷ đơn',
  noteOrder: 'Ghi chú đơn hàng',
  reasonCancel: 'Lý do huỷ',
  note: 'Ghi chú',
  contact: 'Liên hệ',
  contactSeller: 'Liên hệ nhà bán hàng',
  changeAddressShipping: 'Đổi địa chỉ giao hàng',
  buyAgain: 'Mua lại',
  orderManagement: 'Quản lý đơn hàng',
  detailOrders: 'Chi tiết đơn hàng',
  back: 'Quay lại',
  typeProduct: 'Loại sản phẩm',
  managementProduct: 'Quản lý sản phẩm',
  infoStore: 'Thông tin cửa hàng',
  addToCart: 'Thêm vào giỏ',
  addedToCart: 'Đã thêm vào giỏ',
  buyNow: 'Mua ngay',
  store: 'Cửa hàng',
  buyContact: 'Gọi điện thoại đặt hàng',
  phone: 'Số điện thoại',
  phoneContact: 'Số điện thoại liên hệ',
  notRegister: 'Chưa đăng ký',
  retail: 'Mua lẻ',
  wholesale: 'Mua sỉ',

  //address
  deleteAddress: 'Xoá địa chỉ',
  addAddress: 'Thêm địa chỉ',
  addAddressPlus: '+ Thêm địa chỉ',
  editAddress: 'Sửa địa chỉ',
  changeShippingAddress: 'Đổi địa chỉ giao hàng',
  yourPickupAddressList: 'Danh sách các địa chỉ của bạn để nhân viên giao hàng tới nhận hàng để vận chuyển',

  //account
  managementAccount: 'Quản lý tài khoản',
  account: 'Tài khoản',
  changePassword: 'Đổi mật khẩu',
  infoGeneral: 'Thông tin chung',
  settingPassword: 'Cài đặt mật khẩu',
  infoAccount: 'Thông tin tài khoản',
  numberAddress: 'Số địa chỉ',
  currentPasswordIncorrect: 'Mật khẩu hiện tại không đúng',
  loginPromptTitle: "Đăng nhập ngay để có trải nghiệm tốt nhất",
  sellerPlatformTitle: "Bán hàng trên FUTA FuNong",
  createPassword: "Tạo mật khẩu",

  //Empty
  emptyNotification: 'Bạn chưa có thông báo nào',
  emptySearch: 'Không tìm thấy kết quả phù hợp! Vui lòng thử lại với kết quả tìm kiếm khác.',
  emptyAddress: 'Bạn chưa cập nhật địa chỉ. Vui lòng bổ sung để tiếp tục!',
  emptyShoppingCart: 'Bạn chưa có sản phẩm nào trong giỏ hàng',
  emptyOrder: 'Bạn chưa có đơn hàng nào',

  //shipping config
  shippingConfig: 'Cấu hình vận chuyển',
  saving: 'Đang lưu...',
  saveChanges: 'Lưu thay đổi',
  selfDeliveryDisableTitle: 'Bạn không thể tắt tính năng Nhà bán hàng tự vận chuyển',
  selfDeliveryDescription: 'Chọn phương thức vận chuyển cho các đơn trên gian hàng của bạn',
  selfDeliveryTitle: 'Nhà bán hàng tự vận chuyển',
  selfDeliveryOption: 'Chấp nhận các đơn hàng được giao tại các địa điểm mà không có đơn vị vận chuyển nào hỗ trợ',
  selfDeliverySublabel: '(nhà bán hàng tự đi giao)',
  partnerDeliveryTitle: 'Vận chuyển bởi đối tác của FUTA FuNong',
  shippingCostNote: 'Người mua sẽ chịu phí giao hàng cho đối tác vận chuyển khi nhận hàng',
}
